import { Box, Flex, FlexProps, Text, TextProps } from '@chakra-ui/react';
import { PropsWithChildren, ReactNode } from 'react';
import colors from 'src/theme/colors';

interface InfoMessageProps extends FlexProps {
  LeftElement?: ReactNode;
  RightElement?: ReactNode;
  textProps?: TextProps;
}

export default function InfoMessage({
  LeftElement,
  RightElement,
  children,
  textProps,
  ...props
}: PropsWithChildren<InfoMessageProps>) {
  return (
    <Flex
      p="12px 12px"
      border={`2px solid ${colors.podcastShade200}`}
      bg="podcastShade100"
      mb="12px"
      borderRadius="12px"
      justifyContent="space-between"
      {...props}
    >
      {LeftElement && <Box>{LeftElement}</Box>}
      <Text visual="popover" color="podcastShade700" pl="10px" {...textProps}>
        {children}
      </Text>
      {RightElement && <Box>{RightElement}</Box>}
    </Flex>
  );
}
